import $ from 'jquery';
import { addScript } from "../../bundles/helpers/add-script";
(($) => {
  let timeout = null;
  $(document)
        .ready(() => {
          const $elem = $('.navigation');
          if ($elem.length) {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach(({type, target}) => {
                if (type === 'attributes') {
                  const $target = $(target);
                  const $fixed = $('[data-target="swap-fixed"]');
                  const $static = $('[data-target="swap-static"]');
                  window.matchMedia('(min-width:992px)').matches && $target.hasClass('fixed-top') ?
                    $fixed.append($static.children().addClass('fixed')):
                    $static.append($fixed.children().removeClass('fixed'));
                }
              });
            });
            $elem.each((i, elem) => observer.observe(elem, {attributes: true}));
          }
        })
        .on('mouseenter', '.navigation__link[data-target]', async (event)=> {
          if ($ && !$.fn.select2) {
            await addScript(PUBLIC_PATH + 'vendor/select2/select2.vendor.js');
            await addScript(PUBLIC_PATH + 'vendor/select2/ru.vendor.js');
          }
            clearInterval(timeout);
            const $links = $('.navigation__link[data-target]');
            const $current = $(event.target);
            const $block = $current.closest('.navigation');
            const $tab = $($current.data('target'));
            $('.select2-hidden-accessible').select2('close');
            $block.addClass('navigation-open');
            $block.find('.tab-pane').removeClass('active show');
            $links.removeClass('hover');
            $tab.addClass('active show');
            $current.addClass('hover');
        })
        .on('mouseenter', '.navigation__dropdown', () => clearInterval(timeout))
        .on('mouseleave', '.navigation, .navigation__dropdown, .navigation [data-target]', (event) => {
            clearInterval(timeout);
            timeout = setTimeout(() => {
                const $links = $('.navigation__link[data-target]');
                const $current = $(event.target);
                const $block = $current.closest('.navigation');
                $links.removeClass('hover');
                $block.removeClass('navigation-open');
            }, 100);
        });
})($);
